import { render } from "./liquidation-count.vue?vue&type=template&id=489a7133&scoped=true"
import script from "./liquidation-count.vue?vue&type=script&lang=js"
export * from "./liquidation-count.vue?vue&type=script&lang=js"

import "./liquidation-count.vue?vue&type=style&index=0&id=489a7133&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489a7133"]])

export default __exports__